export const EXCEL_FILE_TYPES = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

export const VERIFICATION_ALLOWED_FILE_TYPES = ["text/csv", "application/pdf", ...EXCEL_FILE_TYPES];
